import React from 'react';
import Button from '@material-ui/core/Button';
import Camera from 'material-ui/svg-icons/image/camera-alt';
import createConnectedField from 'utils/createConnectedField';
import ToastActions from '@store/toast/ToastActions';
import FieldContainer from 'components/pure/utils/form/FieldContainer';
import FileField from 'components/pure/utils/form/FileField';
import InputField from 'components/pure/utils/form/InputField';
import UserAvatar from 'components/pure/utils/UserAvatar';
import './UserBasicInfo.styl';
import {ADMIN_EDIT_USER_FIELD_SLACK_EMAIL} from 'utils/const/adminEditUserFields';
import AdminEditUserActions from 'actions/admin/AdminEditUserActions';
import {TimezoneAutocomplete} from 'components/pure/admin/TimezoneAutocomplete';

export default class UserBasicInfo extends React.PureComponent {
  constructor(props) {
    super(props);

    this.AdminUserInputField = createConnectedField(InputField, AdminEditUserActions);

    this.handleDrop = this.handleDrop.bind(this);
  }
  getError(field) {
    const errorMessage = this.props.formState.getIn(['fieldErrors', field]);
    const fieldTouched = this.props.formState.getIn(['fieldTouched', field]);
    const allFieldTouched = this.props.formState.get('allTouched');

    if (fieldTouched || allFieldTouched) {
      return errorMessage;
    }
  }

  getUserAvatarOptions() {
    const {formState, avatar, userId} = this.props;
    const currentAvatar = formState.getIn(['fieldValues', 'userInfo', 'avatar']);
    let avatarUrl = avatar || currentAvatar;
    if (avatarUrl instanceof File) {
      avatarUrl = avatarUrl.preview;
    }

    let firstName = formState.getIn(['fieldValues', 'userInfo', 'firstName']);
    const color = formState.getIn(['fieldValues', 'userInfo', 'color']);
    firstName = firstName ? firstName.trim() : firstName;
    let lastName = formState.getIn(['fieldValues', 'userInfo', 'lastName']);
    lastName = lastName ? lastName.trim() : lastName;

    return {
      id: userId,
      firstName: firstName,
      lastName: lastName,
      avatar: avatarUrl,
      color: color,
    };
  }

  handleDrop(acceptedFiles, rejectedFiles) {
    // handle rejected file upload
    if (rejectedFiles.length > 0) {
      ToastActions.addToast({
        type: 'error',
        message: "File type can't be handled.",
      });
    }
  }

  render() {
    const {formState, enableEmailChange = true, hasSlack, hasSlackLoaded} = this.props;

    return (
      <div className="user-basic-info">
        <FieldContainer label="First Name" error={this.getError('firstName')}>
          <this.AdminUserInputField
            formState={formState.fieldValues.userInfo}
            name="firstName"
            placeholder="First Name"
            type="text"
          />
        </FieldContainer>
        <FieldContainer label="Last Name" error={this.getError('lastName')}>
          <this.AdminUserInputField
            formState={formState.fieldValues.userInfo}
            name="lastName"
            placeholder="Last Name"
            type="text"
          />
        </FieldContainer>
        <FieldContainer label="E-mail Address" error={this.getError('email')}>
          <this.AdminUserInputField
            formState={formState.fieldValues.userInfo}
            disabled={!enableEmailChange}
            name="email"
            placeholder="Email"
            type="email"
            title={
              !enableEmailChange
                ? "Ask an account administrator if you'd like to change your email address"
                : undefined
            }
          />
        </FieldContainer>
        {hasSlack && hasSlackLoaded && (
          <FieldContainer
            label="Slack Email"
            error={this.getError(ADMIN_EDIT_USER_FIELD_SLACK_EMAIL)}>
            <this.AdminUserInputField
              formState={formState.fieldValues.userInfo}
              name={ADMIN_EDIT_USER_FIELD_SLACK_EMAIL}
              placeholder="Email"
              type="email"
            />
          </FieldContainer>
        )}
        <FieldContainer label="Profile Image" labelType="div" error={this.getError('avatar')}>
          <FileField
            onChange={this.props.setAvatar}
            name="avatar"
            className="profile-image-field"
            accept="image/*"
            multiple={false}
            maxSize={4000000} // 4MB
            dropzoneOnDrop={this.handleDrop}>
            <UserAvatar user={this.getUserAvatarOptions()} overrideUrl={!!this.props.avatar} />
            <Button variant="outlined" className="ev-button">
              <Camera />
              Add Photo
            </Button>
          </FileField>
        </FieldContainer>
        <FieldContainer label="Timezone" className="new-timezone" error={this.getError('timezone')}>
          <TimezoneAutocomplete
            value={formState.fieldValues.userInfo.timezone}
            setUserZone={tz => {
              AdminEditUserActions.changeField('timezone', tz);
            }}
          />
        </FieldContainer>
      </div>
    );
  }
}
